// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"e23e2329","238":"0bb17147","593":"93518215","652":"913dba00","770":"64c995b8"}[chunkId] + ".chunk.js";
};